import { ForwardedRef, forwardRef } from 'react';

import { ContainerOptions, RowColumnProps, resolveClasses } from './config';

import { cn } from 'styles';

export type ColumnProps<As extends ContainerOptions = 'div'> = RowColumnProps<As>;

const ColumnBase = <As extends ContainerOptions = 'div'>(
  { children, as, title, onSubmit, gap = '4', styles, ...styleConfig }: ColumnProps<As>,
  ref: ForwardedRef<HTMLElement>,
) => {
  const Comp = as || 'div';

  return (
    <Comp
      className={cn('flex-col', resolveClasses({ gap, ...styleConfig }))}
      onSubmit={onSubmit}
      title={title}
      ref={ref as never}
      style={styles}
    >
      {children}
    </Comp>
  );
};

export const Column = forwardRef(ColumnBase);
